export enum Channels {
    Note = 'note',
    Email = 'email',
    SMS = 'sms',
    FormSubmissions = 'Form Submissions',
    WhatsApp = 'WhatsApp',
}
